import script from "./QTI.vue?vue&type=script&lang=ts&setup=true"
export * from "./QTI.vue?vue&type=script&lang=ts&setup=true"

import "./QTI.vue?vue&type=style&index=0&id=4b4a349b&lang=scss&scoped=true"
import "./QTI.vue?vue&type=style&index=1&id=4b4a349b&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b4a349b"]])

export default __exports__